import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project import
// import LogoMain from './LogoMain';
// import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH } from 'config';
// import LogoServicepack from 'assets/images/common/ServicePackSmallLogo.svg';
// import MainServicepackLogo from 'assets/images/common/ServicePackFullLogo.svg';
// import ServicepackWhiteSmallLogo from 'assets/images/common/ServicepackWhiteSmallLogo.svg';
// import ServicepackWhiteFullLogo from 'assets/images/common/ServicepackWhiteFullLogo.svg';
// import finalLogo from 'assets/images/common/v2a.png';
import { useTheme } from '@mui/styles';
import { Star1 } from 'iconsax-react';
import useAuth from 'hooks/useAuth';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({ isIcon, sx, to }) => {
  const theme = useTheme();
  const { tenantLogo } = useAuth();
  return (
    <ButtonBase disableRipple component={Link} to={!to ? APP_DEFAULT_PATH : to} sx={{ pt: theme.spacing(2), ...sx }}>
      {isIcon ? (
        <div>
          {/* <img src={theme.palette.mode === 'dark' ? finalLogo : finalLogo} alt="smalllogo" style={{ height: '100%', width: '100%' }} /> */}
          <Star1 color={theme.palette.primary.main} variant="Bold" />
        </div>
      ) : (
        <div style={{ width: '200px' }}>
          <img
            // src={theme.palette.mode === 'dark' ? finalLogo : finalLogo}
            src={tenantLogo}
            alt="fulllogo"
            style={{ padding: '0px 24px', height: '100%', width: '100%' }}
          />
        </div>
      )}
    </ButtonBase>
  );
};

LogoSection.propTypes = {
  reverse: PropTypes.bool,
  isIcon: PropTypes.bool,
  sx: PropTypes.object,
  to: PropTypes.string
};

export default LogoSection;
